export const ACCESS_HINT = `
  Creep actions claimController, upgradeController, <br />
  and reserveController work only when the shard <br />
  access is unlocked. Everything else works as usual.
`;
